import React from 'react';
import {connect} from "react-redux";
import $ from "jquery";
import {FormattedMessage} from "react-intl";

import {
  setShowUnlockCalculationsTutorial,
  setUnlockCalculationsTutorialFinished,
  setUnlockCalculationsTutorialStep
} from "../../actions/unlockCalculationsFunctions";
import UnlockCalculationsTutorialFunctions from "./unlockCalculationsTutorialFunctions";

class UnlockCalculationsTutorialLowes extends UnlockCalculationsTutorialFunctions {

  constructor(props) {
    super(props);
    this.state = {
      ringStyles: {
        left: 0,
        top: 0,
      },
      buttonStyles: {
        left: 0,
        top: 0,
      },
    };
    this.resizeId = 0;
  }

  componentDidMount = () => {
    // $(".tutorial-step").fadeIn(300);
    this.setButtonsPositions();
    setTimeout(() => {  // wait until countertop button calculates
      $(this.overlayElement).fadeIn(300);
    }, 300);
    window.addEventListener("resize", this.handleResize);
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    clearTimeout(this.resizeId);
    this.resizeId = setTimeout(this.setButtonsPositions, 500);
  };

  setButtonsPositions = () => {
    this.changeHighlightRingPosition(".selection-main__image-button.selection-main__image-button--fullscreen");
    this.changeHighlightRingPosition(".ui-button2.ui-button2--green.pulsating--green", "buttonStyles");
  };

  render() {
    const {ringStyles, buttonStyles} = this.state;
    return (
      <div className={"tutorial-overlay tutorial-overlay--calculations"} ref={(node) => this.overlayElement = node}>
        <div className={"tutorial"}>
          <div className="tutorial-sections">
            <div className="tutorial-section tutorial-section--inspiration">
              <div className="tutorial-step__ring tutorial-step__ring--design-small" style={{
                transform: "translate("+ringStyles.left+"px, "+ringStyles.top+"px)",
              }}>
                <button className="selection-main__image-button selection-main__image-button--fullscreen"
                        onClick={this.exitTutorial}/>
              </div>
              <div className="tutorial-section__image"/>
              <h3 className="tutorial-section__title bold">
                <FormattedMessage id="shoppingCart.unlockCalculationsTutorial.Lowes.leftSectionText"/>
              </h3>
              <div className="tutorial-section__arrow" style={this.props.windowWidth < 991 ? {
                transform: "translate("+ringStyles.left+"px, "+ringStyles.top+"px)",
              } : {}}/>
            </div>
            <div className="tutorial-section tutorial-section--click-here">
              <div className="tutorial-step__ring tutorial-step__ring--final-button" style={{
                transform: "translate("+buttonStyles.left+"px, "+buttonStyles.top+"px)",
              }}>
                <button className="ui-button2 ui-button2--green pulsating--green"
                          onClick={this.exitTutorial}>
                  <FormattedMessage id="shoppingCart.unlockCalculationsTutorial.Lowes.rightSectionButton"/>
                </button>
              </div>
              <div className="tutorial-section__image"/>
              <h3 className="tutorial-section__title bold">
                <FormattedMessage id="shoppingCart.unlockCalculationsTutorial.Lowes.rightSectionText"/>
              </h3>
              <div className="tutorial-section__arrow"/>
            </div>
          </div>
          <div className="tutorial-central-button">
            <button className="ui-button2 ui-button2--green ui-button3--wide"
                    onClick={this.exitTutorial}>
              <FormattedMessage id="shoppingCart.unlockCalculationsTutorial.Lowes.centralButton"/>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    unlockCalculationsTutorialStep: store.unlockCalculationsState.unlockCalculationsTutorialStep,
    windowWidth: store.serverState.windowWidth,
  };
};

export default connect(mapStateToProps, {
  setUnlockCalculationsTutorialStep,
  setShowUnlockCalculationsTutorial,
  setUnlockCalculationsTutorialFinished
})(UnlockCalculationsTutorialLowes);
